import { getSupabaseClient } from './Supa';
import { currentUser$ } from './Firebase';
import { Tables } from './database.types';

export async function createChatSession(characterId: string): Promise<Tables<'chat_sessions'>> {
  const user = currentUser$.get();
  if (!user) {
    throw new Error('User must be authenticated to create a chat session');
  }

  const supabase = getSupabaseClient();
  const { data, error } = await supabase
    .from('chat_sessions')
    .insert({
      user_id: user.uid,
      character_id: characterId,
    })
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
}

export async function createMessage(
  sessionId: string,
  role: 'user' | 'assistant',
  content: string,
  imageUrl?: string
): Promise<Tables<'messages'>> {
  const supabase = getSupabaseClient();
  const insertData: { session_id: string; role: string; content: string; image_url?: string } = {
    session_id: sessionId,
    role,
    content,
  };
  if (imageUrl) {
    insertData.image_url = imageUrl;
  }
  const { data, error } = await supabase
    .from('messages')
    .insert(insertData)
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
}

export async function getChatSessions(characterId?: string): Promise<Tables<'chat_sessions'>[]> {
  const user = currentUser$.get();
  if (!user) {
    return [];
  }

  const supabase = getSupabaseClient();
  let query = supabase
    .from('chat_sessions')
    .select('*')
    .eq('user_id', user.uid);

  if (characterId) {
    query = query.eq('character_id', characterId);
  }

  const { data, error } = await query.order('created_at', { ascending: false });

  if (error) {
    throw error;
  }

  return data || [];
}

export async function getMessages(sessionId: string): Promise<Tables<'messages'>[]> {
  const supabase = getSupabaseClient();
  const { data, error } = await supabase
    .from('messages')
    .select('*')
    .eq('session_id', sessionId)
    .order('created_at', { ascending: true });

  if (error) {
    throw error;
  }

  return data || [];
}
